import { ShippingRecord } from '../../types';

export type SortField = 'date' | 'licensePlate' | 'destination' | 'province' | 'shippingCost' | 'prepaidAmount' | 
    'loadUnloadFee' | 'tollFee' | 'fuelCost' | 'fuelEfficiency' | 'rM2Fee' | 'repairCost' | 'driverSalary' | 'salaryRate' | 'totalFee';
export type SortDirection = 'asc' | 'desc';

export const getDestinationDisplay = (record: ShippingRecord): string => {
  if (record.districtName) {
    return record.districtName;
  }
  return record.shippingAddress.length > 20 
    ? record.shippingAddress.substring(0, 20) + '...'
    : record.shippingAddress;
};

export const sortRecords = (recordsToSort: ShippingRecord[], field: SortField, direction: SortDirection) => {
  return [...recordsToSort].sort((a, b) => {
    let aValue: any;
    let bValue: any;

    switch (field) {
      case 'date':
        aValue = new Date(a.shippingDate).getTime();
        bValue = new Date(b.shippingDate).getTime();
        break;
      case 'licensePlate':
        aValue = a.licensePlate;
        bValue = b.licensePlate;
        break;
      case 'destination':
        aValue = getDestinationDisplay(a);
        bValue = getDestinationDisplay(b);
        break;
      case 'province':
        aValue = a.provinceName || '';
        bValue = b.provinceName || '';
        break;
      case 'shippingCost':
        aValue = a.shippingCost || 0;
        bValue = b.shippingCost || 0;
        break;
      case 'prepaidAmount':
        aValue = a.prepaidAmount || 0;
        bValue = b.prepaidAmount || 0;
        break;
      case 'loadUnloadFee':
        aValue = a.loadUnloadFee || 0;
        bValue = b.loadUnloadFee || 0;
        break;
      case 'tollFee':
        aValue = a.tollFee || 0;
        bValue = b.tollFee || 0;
        break;
      case 'fuelCost':
        aValue = a.fuelCost || 0;
        bValue = b.fuelCost || 0;
        break;
      case 'fuelEfficiency':
        aValue = a.fuelEfficiencyLitersPer100Km || 999; // High value for records without efficiency
        bValue = b.fuelEfficiencyLitersPer100Km || 999;
        break;
      case 'rM2Fee':
        aValue = a.rM2Fee || 0;
        bValue = b.rM2Fee || 0;
        break;
      case 'repairCost':
        aValue = a.repairCost || 0;
        bValue = b.repairCost || 0;
        break;
      case 'driverSalary':
        aValue = a.driverSalary || 0;
        bValue = b.driverSalary || 0;
        break;
      case 'salaryRate':
        aValue = a.salaryRate || 0;
        bValue = b.salaryRate || 0;
        break;
      case 'totalFee':
        aValue = (a.loadUnloadFee || 0) + (a.tollFee || 0) + (a.fuelCost || 0) + (a.rM2Fee || 0) + (a.repairCost || 0);
        bValue = (b.loadUnloadFee || 0) + (b.tollFee || 0) + (b.fuelCost || 0) + (b.rM2Fee || 0) + (b.repairCost || 0);
        break;
      default:
        return 0;
    }

    if (typeof aValue === 'string' && typeof bValue === 'string') {
      return direction === 'asc' 
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    }

    return direction === 'asc' ? aValue - bValue : bValue - aValue;
  });
};

export const getUniqueValues = (records: ShippingRecord[]) => {
  const licensePlates = records
    .map(record => record.licensePlate)
    .filter((plate, idx, arr) => arr.indexOf(plate) === idx)
    .sort();
  const provinces = records
    .map(record => record.provinceName)
    .filter(Boolean)
    .filter((province, idx, arr) => arr.indexOf(province) === idx)
    .sort();
  return { licensePlates, provinces };
};
